export default __webpack_public_path__ + "fa9b817cf4ca682420b2a5ae5d64f94d.svg";